import {
  HOME_LOAD_PROJECT_DETAIL_BEGIN,
  HOME_LOAD_PROJECT_DETAIL_SUCCESS,
  HOME_LOAD_PROJECT_DETAIL_FAILURE,
  HOME_LOAD_PROJECT_DETAIL_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { Mixpanel } from '../../../common/utils/mixpanelUtil';

export function loadProjectDetail(args = {}) {
  return (dispatch) => {
    dispatch({
      type: HOME_LOAD_PROJECT_DETAIL_BEGIN,
    });
    const { projectId, version } = args;
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/`,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: HOME_LOAD_PROJECT_DETAIL_SUCCESS,
            data: res.data,
          });
          const { name, seoName, uuid } = res.data;
          Mixpanel.register({ projectName: name, seoName, projectUuid: uuid });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: HOME_LOAD_PROJECT_DETAIL_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadProjectDetailError() {
  return {
    type: HOME_LOAD_PROJECT_DETAIL_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case HOME_LOAD_PROJECT_DETAIL_BEGIN:
      return {
        ...state,
        loadProjectDetailPending: true,
        loadProjectDetailError: null,
      };

    case HOME_LOAD_PROJECT_DETAIL_SUCCESS:
      return {
        ...state,
        loadProjectDetailPending: false,
        loadProjectDetailError: null,
        projectDetail: action.data,
      };

    case HOME_LOAD_PROJECT_DETAIL_FAILURE:
      return {
        ...state,
        loadProjectDetailPending: false,
        loadProjectDetailError: action.data.error,
      };

    case HOME_LOAD_PROJECT_DETAIL_DISMISS_ERROR:
      return {
        ...state,
        loadProjectDetailError: null,
      };

    default:
      return state;
  }
}
